import "rothzerg-ui/styles";
import { RothzergProvider, TooltipProvider, Toaster } from "rothzerg-ui";
import config from "../../rothzerg.config";

type AppProvidersProps = {
  children: React.ReactNode;
};

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <RothzergProvider config={config}>
      <TooltipProvider>
        <Toaster position="top-right">{children}</Toaster>
      </TooltipProvider>
    </RothzergProvider>
  );
}
